import { Component } from '@angular/core';

@Component({
  selector: 'app-layout',
  template: '<router-outlet><spinner></spinner></router-outlet>'
})
export class AuthLayoutComponent {}



// WEBPACK FOOTER //
// D:/Angular projects/memberreg/memberreg/src/app/layouts/auth/auth-layout.component.ts